var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoKeys = function SvgNoKeys(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#no_keys_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.53.47A.75.75 0 0 0 .47 1.53l22 22a.75.75 0 1 0 1.06-1.06l-1.56-1.56c.1-.285.155-.592.155-.91V4a2.75 2.75 0 0 0-2.75-2.75H4.625a2.74 2.74 0 0 0-1.714.6zM20.625 4v15.564l-5.549-5.548h1.794V2.75h2.505c.69 0 1.25.56 1.25 1.25M13.37 2.75v9.56l-2.745-2.746V2.75zm-6.245 0h-2.5c-.233 0-.452.064-.639.175l3.139 3.14z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.375 7.938a.75.75 0 0 0-1.5 0V20a2.75 2.75 0 0 0 2.75 2.75h12.063a.75.75 0 0 0 0-1.5H9.625v-7.125a.75.75 0 0 0-1.5 0v7.125h-3.5c-.69 0-1.25-.56-1.25-1.25z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "no_keys_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNoKeys;